import React, { useState, useRef } from 'react';
import InputMask from 'react-input-mask';

const FloatingLabelInput = ({ label, mask, value, onChange, type = "text", readOnly = false }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  // Ref callback to avoid findDOMNode warning
  const setInputRef = (element) => {
    inputRef.current = element;
  };

  const baseInputClasses =
    "w-full h-10 rounded-xl border border-gray-300 bg-gray-100 text-base text-gray-800 outline-none focus:border-green-600 focus:ring-1 focus:ring-green-600 transition";

  const inputClasses = label
    ? `${baseInputClasses} pt-5 pb-1 px-4`
    : `${baseInputClasses} py-2 px-4`;

  const wrapperClasses = "relative w-full text-base";

  const inputProps = {
    value: value || '',
    onChange,
    type,
    className: inputClasses,
    onFocus: handleFocus,
    onBlur: handleBlur,
    readOnly,
  };

  return (
    <div className={wrapperClasses}>
      {label && (
        <label
          className={`absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 transition-all text-sm pointer-events-none ${
            isFocused || value ? 'top-2 text-xs text-green-600' : ''
          }`}
        >
          {label}
        </label>
      )}
      {mask ? (
        <InputMask
          mask={mask}
          {...inputProps}
          inputRef={setInputRef}
        />
      ) : (
        <input
          {...inputProps}
          ref={inputRef}
        />
      )}
    </div>
  );
};

export default FloatingLabelInput;